<section id="problem" class="wl-section problem">
  <div class="wl-inner inner">
    <app-section-heading
      eyebrow="Dlaczego to działa"
      title='To nie kolejna "zabawa"'
      subtitle="Każdy gość poczuje różnicę." />
    <div class="wl-2col">
      <div class="card">
        <p class="card-label">Klasyczna zabawa</p>
        <div class="items">
          @for (item of classic; track item) {
            <div class="item"><span class="dot"></span><span class="text">{{ item }}</span></div>
          }
        </div>
      </div>
      <div class="card ours">
        <div class="corner"></div>
        <p class="card-label accent">Wesele Live</p>
        <div class="items on-top">
          @for (item of weseleLive; track item) {
            <div class="item"><span class="dot accent"></span><span class="text dark">{{ item }}</span></div>
          }
        </div>
      </div>
    </div>
  </div>
</section>
